/**
 * PDF text extraction utilities using pdfjs-dist
 */
import * as pdfjsLib from 'pdfjs-dist';

// Set the worker source
pdfjsLib.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdfjs/pdf.worker.min.js`;

/**
 * Extract text content from a PDF file
 * @param {File} file - The PDF file object
 * @returns {Promise<Object>} - Contains text content and metadata
 */
export const extractPdfText = async (file) => {
  try {
    console.log(`Starting PDF extraction for ${file.name}...`);
    
    // Convert file to ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();
    
    // Load the PDF document
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdfDoc = await loadingTask.promise;
    
    const pageCount = pdfDoc.numPages;
    console.log(`PDF has ${pageCount} pages`);
    
    // Extract text from each page
    const textContent = [];
    for (let i = 1; i <= pageCount; i++) {
      const page = await pdfDoc.getPage(i);
      const content = await page.getTextContent();
      const strings = content.items.map(item => item.str);
      textContent.push(strings.join(' '));
    }
    
    // Join all pages with page breaks
    const fullText = textContent.join('\n\n--- Page Break ---\n\n');
    
    console.log(`Extracted ${fullText.length} characters from PDF`);
    
    return {
      content: fullText || `[No readable text content found in ${file.name}]`,
      pageCount
    };
  } catch (error) {
    console.error('Error extracting PDF text:', error);
    return {
      content: `[Error extracting text from ${file.name}: ${error.message}]`,
      pageCount: null
    };
  }
};
